module.exports = __webpack_public_path__ + "assets/img/4_111_big.db866f41.jpg";